import React from 'react';

export const renderSubsitesInfo = (
	parentSite,
	hoveringOverSite,
	onItemMouseOver,
	onItemMouseLeave
) => {
    const highlightedStyle = {fontWeight: '500', color: 'black'}
    const normalStyle = {fontWeight: 'normal', color: '#333'}

	return (
		<div id="sitesAndSubsitesMenu" style={{ marginRight: '10px' }}>
			<ul style={{ fontSize: '20px', paddingRight: '10px' }}>
				<li
					style={hoveringOverSite === parentSite.site.id ? highlightedStyle : normalStyle}
				>
					{parentSite.site.id}
				</li>

				{parentSite.subsiteAOIs.map((ss, idx) => (
					<li
						style={hoveringOverSite === ss.id ? highlightedStyle : normalStyle}
						key={idx}
						onMouseEnter={onItemMouseOver}
						onMouseLeave={onItemMouseLeave}
						title={ss.name}
					>
						{ss.id}
					</li>
				))}
			</ul>
		</div>
	);
};
